import * as React from 'react';
import {
  AutomationAction,
  AUTOMATION_ACTION_TYPE,
} from '../../../MedicareProAPI/Entities/Automation/AutomationAction';
import { AUTOMATION_TRIGGER_DATA_FIELD_TYPE_LABELS } from '../../Language/en';
import { INDIVIDUAL_POLICY_STATUS_TYPE } from '../../../MedicareProAPI/Entities/Ind/IndPolicy';
import { UserLeadStatusSelect } from '../Form/Field/UserLeadStatusSelect';
import { UserFlagSelect } from '../Form/Field/UserFlagSelect';
import { UserSourceSelect } from '../Form/Field/UserSourceSelect';
import { MultiSelect } from '../Form/Field/MultiSelect';
import { MultiSelectModal } from '../Form/Field/MultiSelectModal';
import { PlanTypeSelect } from '../Form/Field/PlanTypeSelect';
import { SelectMap } from '../../Utilities/SelectMap';
import { IndPolicyStatusSelect } from '../Form/Field/IndPolicyStatusSelect';
import { IndStatusSelect } from '../Form/Field/IndStatusSelect';
import { IndPolicyWrittenAsSelect } from '../Form/Field/IndPolicyWrittenAsSelect';
import { IndPrefLangSelect } from '../Form/Field/IndPrefLangSelect';
import { IndGenderSelect } from '../Form/Field/IndGenderSelect';
import type {
  AUTOMATION_TRIGGER_COMBINATION,
  AutomationActionTriggerData,
} from '../../../MedicareProAPI/Entities/Automation/Automation';
import {
  AUTOMATION_ACTION_TRIGGER_TYPE,
  AUTOMATION_TRIGGER_DATA_FIELD_TYPE,
} from '../../../MedicareProAPI/Entities/Automation/Automation';
import type { AutomationTriggerRecipe } from '../../Panels/AgentAutomationManagePanel';
import { AUTOMATION_ACTION_TRIGGER_RECIPES } from '../../Panels/AgentAutomationManagePanel';
import { IndAgeSelect } from '../Form/Field/IndAgeSelect';
import { IndPolicyCompanySelect } from '../Form/Field/IndPolicyCompanySelect';
import { IndUpcomingBirthdaySelect } from '../Form/Field/IndUpcomingBirthdaySelect';

export interface AutomationActionFormTriggerProps {
  automationId?: number;
  triggerData: AutomationActionTriggerData[];
  userAccessToken: string;
  userId: number;
  recipe: AUTOMATION_TRIGGER_COMBINATION;
  shared?: boolean;
  automationHasParent?: boolean;
  onChange: (triggerData: AutomationActionTriggerData[]) => void;
}

export const AutomationActionFormTrigger = (
  props: AutomationActionFormTriggerProps
): React.JSX.Element => {
  const [recipeData, setRecipeData] = React.useState<AutomationTriggerRecipe>();
  const [triggerData, setTriggerData] = React.useState<AutomationActionTriggerData[]>(
    props.triggerData || null
  );
  const [newDataFieldType, setNewDataFieldType] =
    React.useState<AUTOMATION_TRIGGER_DATA_FIELD_TYPE>(undefined);

  const addCriteria = () => {
    const newTriggerData = triggerData ? [...triggerData] : [];

    setNewDataFieldType(undefined);

    const newTriggerDataSinge: AutomationActionTriggerData = {
      field: newDataFieldType,
    };

    newTriggerData.push(newTriggerDataSinge);

    setTriggerData(newTriggerData);
  };

  const handleTriggerDataDelete = (index) => {
    const newTriggerData = [...triggerData];
    newTriggerData.splice(index, 1);

    if (props.onChange) {
      props.onChange(newTriggerData);
    }

    setTriggerData(newTriggerData);
  };

  const handleTriggerDataChange = (index, name, value) => {
    const newTriggerData = [...triggerData];

    newTriggerData[index][name] = value;

    if (props.onChange) {
      props.onChange(newTriggerData);
    }

    setTriggerData(newTriggerData);
  };

  const handleNewDataFieldTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const val = event.target.value as unknown as AUTOMATION_TRIGGER_DATA_FIELD_TYPE;
    setNewDataFieldType(val || undefined);
  };

  React.useEffect(() => {
    setTriggerData(props.triggerData);
  }, [props.triggerData]);

  React.useEffect(() => {
    setTriggerData(props.triggerData ?? []);
    setNewDataFieldType(undefined);
  }, [props.automationId]);

  React.useEffect(() => {
    if (props.recipe) {
      const recipeData = AUTOMATION_ACTION_TRIGGER_RECIPES.find(
        (recipeSinlge) => recipeSinlge.value === props.recipe
      );
      setRecipeData(recipeData);
    } else {
      setRecipeData(null);
    }
  }, [props.recipe]);

  {
    console.log(triggerData);
  }

  return (
    <div className="row">
      <div className="col-12 mt-1">
        <label className="label">
          Event Criteria <em>(Optional)</em>
        </label>
      </div>

      {triggerData &&
        triggerData.length > 0 &&
        triggerData.map((triggerDataSingle, triggerDataIndex) => {
          const rowKey = `${props.automationId}-${triggerDataIndex}-${triggerDataSingle.field ?? 'none'}`;
          const fieldData = AUTOMATION_TRIGGER_DATA_FIELD_TYPE_LABELS.find(
            (label) => label.value === triggerDataSingle.field
          );
          console.log(rowKey);
          if (!fieldData) {
            return false;
          }

          const allValues = triggerDataSingle.allValues || false;

          let SelectObject;
          let multipleValues = true; // TODO: This should live elsewhere and not be a flag like this

          // TODO store this elsewhere so it doesn't need to be a chain of selects
          if (triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.USER_FLAG) {
            SelectObject = UserFlagSelect;
          } else if (triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.USER_SOURCE) {
            SelectObject = UserSourceSelect;
          } else if (triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.PLAN_TYPE) {
            SelectObject = PlanTypeSelect;
          } else if (
            triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.USER_LEAD_STATUS
          ) {
            SelectObject = UserLeadStatusSelect;
          } else if (
            triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_POLICY_STATUS
          ) {
            SelectObject = IndPolicyStatusSelect;
          } else if (
            triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_POLICY_WRITTEN_AS
          ) {
            SelectObject = IndPolicyWrittenAsSelect;
          } else if (
            triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_PREFERRED_LANGUAGE
          ) {
            SelectObject = IndPrefLangSelect;
          } else if (triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_GENDER) {
            SelectObject = IndGenderSelect;
          } else if (triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_AGE) {
            SelectObject = IndAgeSelect;
            multipleValues = false;
          } else if (
            triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_BIRTHDAY_UPCOMING
          ) {
            SelectObject = IndUpcomingBirthdaySelect;
          } else if (triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_STATUS) {
            SelectObject = IndStatusSelect;
          } else if (
            triggerDataSingle.field === AUTOMATION_TRIGGER_DATA_FIELD_TYPE.IND_POLICY_COMPANY
          ) {
            SelectObject = IndPolicyCompanySelect;
          }

          return (
            <div key={rowKey} className="col-12 mt-0 mb-1">
              <div className="border border-secondary rounded bg-light p-2">
                <div className="row">
                  <div className="col-5">
                    <label className="label">
                      <b>{fieldData.label}</b>
                    </label>
                    {multipleValues && (
                      <div className="clearfix">
                        <label className="switch float-left mr-1">
                          <input
                            type="checkbox"
                            disabled={props.automationHasParent || props.shared ? true : false}
                            data-status="off"
                            checked={allValues === true}
                            onChange={(e) => {
                              handleTriggerDataChange(triggerDataIndex, 'allValues', !allValues);
                            }}
                          />
                          <span className="slider round pt-1"></span>
                        </label>

                        <div className="small pt-0">Track all</div>
                      </div>
                    )}
                  </div>
                  <div className="col-6">
                    {allValues === false && (
                      <SelectObject
                        key={`${rowKey}-select`}
                        userAccessToken={props.userAccessToken}
                        userId={props.userId}
                        value={triggerDataSingle.values}
                        disabled={props.automationHasParent || props.shared ? true : false}
                        onChange={(newValue) => {
                          handleTriggerDataChange(triggerDataIndex, 'values', newValue);
                        }}
                      />
                    )}
                  </div>
                  <div className="col-1 text-right">
                    {triggerDataSingle.required !== true && (
                      <button
                        type="button"
                        onClick={(e) => handleTriggerDataDelete(triggerDataIndex)}
                        className="btn btn-sm btn-danger p-1"
                      >
                        <i className="fal fa-times" aria-hidden="true"></i>
                      </button>
                    )}
                  </div>
                  <div className="col-12">
                    {allValues === false &&
                      (!triggerDataSingle.values ||
                        (triggerDataSingle.values && triggerDataSingle.values.length === 0)) && (
                        <div className="rounded table-warning p-1 px-2 mt-1">
                          <small>
                            <i className="far fa-exclamation-circle mr-1 "></i>Please select "Track
                            All" or make a selection.
                          </small>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      {!props.automationHasParent && !props.shared && (
        <>
          <div className="col-3 mt-1">
            <div className="input-group input-group-sm">
              <select
                value={newDataFieldType ?? ''}
                onChange={handleNewDataFieldTypeChange}
                className="form-control form-control-sm"
              >
                <option value="" />
                {AUTOMATION_TRIGGER_DATA_FIELD_TYPE_LABELS.map((item) => {
                  const disabled = !!triggerData?.find((t) => t.field === item.value);
                  const allowed =
                    !recipeData?.availableFilters ||
                    recipeData.availableFilters.includes(item.value);
                  return allowed ? (
                    <option key={item.value} value={item.value} disabled={disabled}>
                      {item.label}
                    </option>
                  ) : null;
                })}
              </select>
            </div>
          </div>
          <div className="col-2 mt-1">
            <button
              type="button"
              onClick={addCriteria}
              disabled={newDataFieldType === undefined}
              className="btn btn-sm border border-primary d-inline-block"
            >
              Add Criteria
            </button>
          </div>
        </>
      )}
    </div>
  );
};
